import { useMutation } from 'react-apollo';

import { broadcastUnsubscribe } from '../graphql/mutations/broadcasts';

/**
 * Hook to unsubscribe from broadcasts.
 *
 * @returns {Object} Object containing onUnsubscribe function and loading state
 */
const useBroadcastUnsubscribe = () => {
  const [broadcastUnsubscribeMutation, { loading }] = useMutation(
    broadcastUnsubscribe,
  );

  const onUnsubscribe = async input => {
    const {
      data: { broadcastUnsubscribe: result },
    } = await broadcastUnsubscribeMutation({
      variables: { input },
    });

    return result;
  };

  return {
    onUnsubscribe,
    loading,
  };
};

export default useBroadcastUnsubscribe;
